import { useFormikContext } from "formik";
import InputFormik from "../../../../../common/components/form/InputFormik";
import { useMemo } from "react";
import { ImCheckboxChecked, ImCheckboxUnchecked } from "react-icons/im";
import { IRenter, RenterReference } from "../../../../../types/renter.type";
import { maskPhone } from "../../../../../common/helpers/mask.helpers";

type ReferencesProps = {
  index: number;
  reference: RenterReference
};

const ReferenceFields: React.FC<ReferencesProps> = (props: ReferencesProps) => {
  const { values, setFieldValue } = useFormikContext();

  const theRef: RenterReference = useMemo(() => (values as IRenter).references[props.index] as RenterReference

    , [(values as any).references]) // eslint-disable-line


  return (
    <div className={`flex flex-col sm:flex-row items-center sm:items-start space-y-2 sm:space-y-0 space-x-0 sm:space-x-2 px-3 py-2 my-3 rounded ${props.index % 2 ? 'bg-gray/5' : 'bg-gray/25'}`}>
      <InputFormik
        name={`references.${props.index}.name`}
        label="Nome do contato:"
        placeholder="Procurar por quem?"
        required={true}
        className="w-full sm:w-2/5"
      />

      <InputFormik
        name={`references.${props.index}.content`}
        label="Número:"
        placeholder="Número"
        required={true}
        mask={maskPhone}
        className="w-full sm:w-2/5"
      />

      <div className="relative h-20 w-full sm:w-1/5 color flex items-center">
        <label htmlFor={`references.${props.index}.verified`} className="block text-sm font-medium text-gray-600">
          {theRef.verified ? (
            <div className="flex gap-2 items-center justify-start text-greenPrimary">
              <ImCheckboxChecked />
              <span>Verificado</span>
            </div>
          ) : (
            <div className="flex gap-2 items-center justify-start text-redPrimary">
              <ImCheckboxUnchecked />
              <span>Não verificado</span>
            </div>
          )}
        </label>
        <input
          id={`references.${props.index}.verified`}
          name={`references.${props.index}.verified`}
          type="checkbox"
          checked={theRef.verified}
          onChange={() => setFieldValue(`references.${props.index}.verified`, !theRef.verified)}
          className="border p-2 rounded w-full absolute opacity-0"
        />
      </div>
    </div>
  );
};

export default ReferenceFields;